import React from "react";
import PropTypes from "prop-types";
import PageletContainer from "@xo-union/react-pagelet";
import { getFooterAssetUrl, getFooterSSIUrl } from "../../utils/urls.js";
import Placeholder from "./Placeholder/index.js";
const handleError = evt => {
  if (evt.detail.isRendered && evt.detail.phase === 'load' && process.env.NODE_ENV === 'production') {
    /**
     * If footer nav is already rendered, do not show error view
     */
    evt.preventDefault();
  }
};

/**
 * Renders a footer nav pagelet which gets dynamically updated as changes to the footer are made.
 *
 * Basides it's own props, this component also accepts all props accepted by the FootereNav component
 */
const FooterNavPagelet = _ref => {
  let {
    tag,
    ssi,
    ...rest
  } = _ref;
  const links = {
    ssi: getFooterSSIUrl(tag, 'index.html'),
    css: getFooterAssetUrl(tag, 'styles.css'),
    js: getFooterAssetUrl(tag, 'main.js')
  };
  return /*#__PURE__*/React.createElement(PageletContainer, {
    onError: handleError,
    renderPlaceholder: Placeholder,
    containerId: "footer-navigation",
    links: links,
    ssi: ssi,
    pageletProps: rest
  });
};
process.env.NODE_ENV !== "production" ? FooterNavPagelet.propTypes = {
  /**
   * Pagelet tag to use. Primary tag will always be `latest` but in cases where we need
   * to maintain support for an older version of the footer pagelet, we will support other tags.
   *
   * The tag can also be a fixed footer pagelet version
   */
  tag: PropTypes.string,
  /**
   * Whether or not to enable SSI. This is recommended to improve rendering performance as this accomplishes
   * server side rendering. NOTE: This requires that the backend server that serves the HTML
   * for the current page to support `ssi` directives.
   */
  ssi: PropTypes.bool
} : void 0;
FooterNavPagelet.defaultProps = {
  tag: 'latest',
  ssi: false
};
export default FooterNavPagelet;